import { formatFieldTypeValue } from "./helpers";

export const generateLoanHeaders = (loan: any) => {
  return Object.keys(loan)
    .map((field) => ({
      label: field,
      key: field,
    }))
    .concat([
      {
        label: "Borrower Company",
        key: "borrower.company.name",
      },
      {
        label: "Borrower First Name",
        key: "borrower.first_name",
      },
      {
        label: "Borrower Last Name",
        key: "borrower.last_name",
      },
      {
        label: "Loan Type",
        key: "loan_type.title",
      },
      {
        label: "Loan Status",
        key: "status.label",
      },
      {
        label: "Location/Address",
        key: "location.formatted",
      },
    ]);
};

export const generateLoanRows = (loans: any[], selectedColumns: any[]) => {
  return loans.map((loan: any) => {
    const values = loan.values;
    const row = {
      // ...loan,
      // borrower_company: loan.borrower.company.name,
      loan_name: loan.name,
      borrower_first_name: loan.borrower.first_name,
      borrower_last_name: loan.borrower.last_name,
      loan_type: loan.loan_type.title,
      loan_status: loan.status.label,
      // location: loan.location.formatted,
    } as any;

    delete row.borrower;
    delete row.user;
    delete row.lender_company;
    delete row.values;
    delete row.contacts;
    delete row.status;
    delete row.draw_requests;

    values.forEach((val: any) => {
      selectedColumns.forEach((column: any) => {
        if (val.loan_field.label === column.label) {
          row[column.label] = formatFieldTypeValue(
            val.loan_field.type,
            val.value.field,
          );
        }
      });
    });
    return row;
  });
};

export const generateBulletPaymentRows = (selectedPayments: any[]) => {
  return selectedPayments.map((payments: any) => {
    const row = {
      ...payments,
    };

    delete row.loan;
    delete row.created_at;
    delete row.id;
    return row;
  });
};

export const generateFees = (selectedFees: any[]) => {
  return selectedFees.map((fees: any) => {
    const row = {
      ...fees,
    };

    delete row.loan;
    delete row.created_at;
    delete row.id;
    return row;
  });
};
